import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpParams } from  '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class EcareConfigurationService {
	base_url = DDP_ENV.userServiceUrl;
	constructor(private _router: Router, private _http: Http, private cookieService: CookieService){}
	/* get  UI preference */
  getConfiguration(path) : Observable<any>{
	return this._http.get(this.base_url + '/ui-config' , this.buildHeadersForGet(path))
    // tslint:disable-next-line:indent
		              .map((res:Response) => res.json());
  }

  private buildHeadersForGet(path): any {
	let params = new HttpParams()
		.set("path", path);
    var headers = new Headers({'Authorization': 'Bearer '+ this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers, params: params });
  }
}
